import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import Cookies from "universal-cookie";
import * as constants from '../../Components/Constant/Constant'
import { normalizeUserType } from "../utils/Accountutils";
import useCurrentUser from "../hooks/useCurrentUser";

const UserContext = createContext();

const cookies = new Cookies();

export const UserProvider = ({ children }) => {

  const [user, setUser] = useState({
    fullName: cookies.get("finuser_fullname") || "",
    userImage: cookies.get("finprofile_image") || "",
  });

  const [showDialog, _setShowDialog] = useState(false);

  const setShowDialog = useCallback((v) => {
    if (v === true && cookies.get("finuserid")) return;
    _setShowDialog(v);
  }, []);

  const [openDialog, setOpenDialog] = useState("login");

  const userId = cookies.get("finuserid") || null;
  const isLoggedIn = !!userId;

  const cookieUser = useMemo(() => ({
    id: userId,
    name: cookies.get("finuser_fullname") || "",
    email: cookies.get("finemail") || "",
    userType: normalizeUserType(cookies.get("finuserType")),
    role: cookies.get("finrole") || null,
    tier: cookies.get("fintier") || null,
  }), [userId]);

  const {
    user: accountUser,
    loading: accountLoading,
    error: accountError,
    refetch: refetchAccount,
  } = useCurrentUser(cookieUser, { enabled: isLoggedIn });

  const userType = normalizeUserType(accountUser?.userType);
  const role = accountUser?.role ?? null;
  const tier = accountUser?.tier ?? null;

  const resetUser = () => {
    setUser({ fullName: "", userImage: "" });
  };

  const updateUser = (updatedUser) => {
    const thirtyday = new Date(Date.now() + 2592000000);
    cookies.set("finuser_fullname", updatedUser.fullName, {
      path: "/",
      expires: thirtyday,
      domain: constants.COOKIES_DOMAIN,
    });
    cookies.set("finprofile_image", updatedUser.userImage, {
      path: "/",
      expires: thirtyday,
      domain: constants.COOKIES_DOMAIN,
    });
    setUser(updatedUser);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        updateUser,
        resetUser,
        accountUser,
        accountLoading,
        accountError,
        refetchAccount,
        isLoggedIn,
        userType,
        role,
        tier,
        showDialog,
        setShowDialog,
        openDialog,
        setOpenDialog,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);